var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.listeners = [];
    }
    EventEmitter.prototype.on = function (listener) {
        this.listeners.push(listener);
    };
    EventEmitter.prototype.off = function (listener) {
        this.listeners = this.listeners.filter(function (l) { return l !== listener; });
    };
    EventEmitter.prototype.emit = function (title) {
        this.listeners.forEach(function (listener) { return listener(title); });
    };
    return EventEmitter;
}());
export var titleEventEmitter = new EventEmitter();
